import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportFilter } from '../bulletin-report-filter';
import { ReportService } from '../bulletin-report.service';
import { Table } from 'primeng/table';
import { registerLocaleData, DatePipe } from '@angular/common';
import localeBr from '@angular/common/locales/pt';

@Component({
    templateUrl: './bulletin-report.component.html',
    styleUrls: ['./bulletin-report.component.css']
})
export class BulletinReportComponent implements OnInit {
    
    exportColumns: any;
    cols: any[];
    rows: any[];

    filter: ReportFilter = new ReportFilter();
    @ViewChild('dt') private elDt: Table;

    constructor(
        private service: ReportService,
        private datepipe: DatePipe
    ) { }

    ngOnInit() {
        registerLocaleData(localeBr);
        
        this.cols = [
            { field: 'lastAccess', header: 'Último Acesso' },
            { field: 'dealerNumber', header: 'Concessionária' },
            { field: 'bulletinCode', header: 'Boletim' },
            { field: 'bulletinDescription', header: 'Descrição' },
            { field: 'vehicle', header: 'Veículo' },
            { field: 'lastUpdate', header: 'Data Última Atualização'},
            { field: 'usrLastUpdate', header: 'Usuário Última Atualização'},
        ];

        this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
    }

    search() {
        this.service.search(this.filter).subscribe(items => {
            this.rows = [];

            //Primeng atualmente não consegue exportar direito o tipo data então converti para string
            items.forEach(item => {
                let row: any = item;
                row['lastAccess'] = this.datepipe.transform(item.lastAccess, 'dd/MM/yyyy HH:mm');
                row['lastUpdate'] = this.datepipe.transform(item.lastUpdate, 'dd/MM/yyyy HH:mm');
                
                this.rows.push(row);
            });
        });
    }

    exportExcel() {
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.rows);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "Bulletin Report");
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }
}